import PageHero from "../components/PageHero";
import Manifesto from "../components/sections/Manifesto";
import TrustStats from "../components/sections/TrustStats";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import BusinessIntro from "../components/sections/BusinessIntro";
import FinalCTA from "../components/sections/FinalCTA";
import Eyebrow from "../components/shared/Eyebrow";
import RevealText from "../components/shared/RevealText";
import { motion } from "framer-motion";
import { viewport } from "../lib/motion";

const PILLARS = [
  ["Who We Are", "A Singapore-based professional cleaning company built on craft, care and consistency."],
  ["What We Do", "Residential and commercial cleaning: post-renovation, end-of-tenancy, deep floor, upholstery and specialised work."],
  ["Our Commitment", "Reliable service, transparent scope and a job left properly finished."],
  ["Properties We Serve", "HDB, BTO, condos, landed homes, offices, retail, F&B and light commercial."],
  ["Professional Equipment", "Commercial rotary scrubbers, HEPA extraction, upholstery machines, electrostatic sprayers."],
  ["Health & Safety", "Trained cleaners, PPE and proper handling of professional chemistry."],
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About Emilio's Solutions"
        headline={"Cleaning Done Right.\nEvery Time."}
        intro="Emilio's Solutions is a Singapore-based professional cleaning company committed to delivering reliable, high-quality service for residential and commercial properties."
        image="/generated/hero_about.png"
        imageAlt="Emilio's Solutions team walking into a Singapore property with equipment"
      />
      <TrustStats />
      <section className="bg-ink py-24 md:py-32">
        <div className="container-emilio">
          <Eyebrow>What We Stand For</Eyebrow>
          <RevealText
            as="h2"
            text={"A cleaning company\nthat actually cleans."}
            className="mt-4 mb-14 font-display font-extrabold text-white text-display max-w-3xl"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal border border-charcoal">
            {PILLARS.map(([title, body], i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={viewport}
                transition={{ delay: i * 0.05, duration: 0.7 }}
                className="bg-ink p-8 md:p-10"
              >
                <div className="text-emerald font-mono text-xs">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-3 font-display font-bold text-white text-xl">
                  {title}
                </h3>
                <p className="mt-3 text-mutedtext text-sm md:text-[15px] leading-relaxed">
                  {body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <BusinessIntro />
      <Manifesto />
      <WhyChooseUs />
      <FinalCTA />
    </>
  );
}
